var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'property-add'},"buttons":[{icon: 'bx bx-edit', title: 'property.update-price.text', link: 'property-update-price'}],"title":_vm.$t('menuitems.property.text')}}),_c('Fastview',{ref:"fast-view",attrs:{"id":"fast-view","title":_vm.viewTitle,"item":_vm.viewObject,"filters":_vm.$options.filters}}),_c('List',{attrs:{"dataList":_vm.propertyData,"edit":{link: 'property-edit'},"deletes":[_vm.deleted, null],"view":{link: 'property-view'},"more":{
          sub: [{
            name: 'property.contract', icon:'bx bx-file', link: 'property/contract', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}
          }, {
            name: 'property.keep', icon:'bx bx-save', link: 'property-keep', column: 'id', show: {column: 'property_status_id', value: 1}
          }, {
            name: 'property.book', icon:'bx bx-calendar-check', link: 'booking/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 1}
          }, {
            name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 1}
          }, {
            name: 'property.sell', icon:'bx bx-cart', link: 'sale/add', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 2}
          }, {
              name: 'booking.delay', icon:'bx bx-time-five', link: 'property-book-delay', column: 'id', show: {column: 'property_status_id', value: 2}
          }, {
            name: 'property.block', icon:'bx bx-block', link: 'property-block', column: 'id', show: {column: 'property_status_id', value: 1}
          }, {
            name: 'property.unkeep', icon:'bx bx-up-arrow-alt', action: 'unkeep', link: 'property-unkeep', column: 'id', show: {column: 'property_status_id', value: 4}
          }, {
            name: 'property.unkeep', icon:'bx bx-up-arrow-alt', action: 'unkeep', link: 'property-unkeep', column: 'id', show: {column: 'property_status_id', value: 5}
          }, {
            name: 'sale.schedule.view', icon: 'bx bx-table', link: 'properties/payment_schedule', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
          }, {
            name: 'sale.commission', icon: 'bx bx-certification', link: 'property-contract', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
          }, {
            name: 'sale.transfer-to-other', icon: 'bx bx-transfer-alt', link: 'property-contract', column: 'id', show: {column: 'property_status_id', value: 3}, target: '_blank'
          }, {
            name: 'property.change-term', icon: 'bx bx-money', link: 'sales/change-term', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 3}
          }, {
            name: 'property.merge.text', icon:'bx bx-git-merge', link: 'property-merge', column: 'id', show: {column: 'property_status_id', value: 1}
          }, {
            name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property-cancelation', column: 'id', show: {column: 'property_status_id', value: 3}
          }, {
            name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property-cancelation', column: 'id', show: {column: 'property_status_id', value: 2}
          }, {
            name: 'property.handover.text', icon: 'bx bx-check-double', link: 'property-handover', column: 'id', show: {column: 'property_status_id', value: 3}
          }, {
            name: 'booking.transfer-property.text', icon: 'bx bx-sync', link: 'booking/transfer', query: 'propertyid', column: 'id', show: {column: 'property_status_id', value: 2}
          }, {
            name: 'property.late-log', icon: 'bx bx-edit-alt', link: 'sale-late', column: 'id', show: {column: 'property_status_id', value: 3}
          }]
        },"filter":{
          search: ['properties.code', 'properties.description'], 
          checkbox: [{
            title: 'property.merge.text',
            field: 'properties.merge_property_id',
            value: 0,
            operator: '!=',
            selected: this.valueMergeProperty
          }],
          dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.status',
            field: 'properties.property_status_id',
            conditions: [{
              value: 2,
              fields: [{
                name: 'properties.temp_type',
                value: 2,
                operator: '=',
                conjuction: 'and'
              }, {
                name: 'properties.temp_expired',
                value: this.$moment().clone().format('YYYY-MM-DD'),
                operator: '>=',
                conjuction: 'and'
              }]
            }, {
              value: 4,
              fields: [{
                name: 'properties.temp_type',
                value: 1,
                operator: '=',
                conjuction: 'and'
              }, {
                name: 'properties.temp_expired',
                value: this.$moment().clone().format('YYYY-MM-DD'),
                operator: '>=',
                conjuction: 'and'
              }]
            }],
            data: this.statusData.data
          }, {
            title: 'property.group',
            field: 'properties.property_group_id',
            data: this.groupData.data
          }, {
            title: 'property.floor',
            field: 'properties.project_floor_id',
            show: 'number',
            data: this.floorData.data
            
          }]
        },"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'code', type: 'fast-view'}, {name: 'status', color: true}, {name: 'currency_en'}, {name: 'price', type: 'currency'}],"fields":[ ("code: " + (_vm.$t('property.code'))), ("project: " + (_vm.$t('property.project'))), ("customer: " + (_vm.$t('menuitems.customer.text'))), ("type: " + (_vm.$t('property.type'))), 
          ("price: " + (_vm.$t('property.price'))), ("currency_en: " + (_vm.$t('property.currency'))), ("status: " + (_vm.$t('property.status')))]},on:{"more":_vm.moreClick,"view":_vm.clickFastView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }